export const DESIGNS_BASE_PATH = '/designs';

/**
 * Overlay stack for Designs — browser Back dismisses each layer without leaving /designs.
 *
 * /designs
 * /designs?preview={id}
 * /designs?preview={id}&order=new|{orderId}
 */
export function parseDesignsOverlay(search) {
  const params = new URLSearchParams(search || '');
  const rawPreview = params.get('preview');
  const rawOrder = params.get('order');
  return {
    preview: rawPreview != null && rawPreview !== '' ? rawPreview : null,
    order: rawOrder != null && rawOrder !== '' ? rawOrder : null,
  };
}

export function buildDesignsSearch({ preview, order } = {}) {
  const params = new URLSearchParams();
  if (preview != null && preview !== '') params.set('preview', String(preview));
  if (order != null && order !== '') params.set('order', String(order));
  const query = params.toString();
  return query ? `?${query}` : '';
}

export function designsNavigateTarget({ preview, order } = {}) {
  return {
    pathname: DESIGNS_BASE_PATH,
    search: buildDesignsSearch({ preview, order }),
  };
}
